import {Component, Input} from '@angular/core';

/**
 * Component that just displays an animated check icon
 */
@Component({
  selector: 'app-animated-check',
  templateUrl: './animated-check.component.html',
  styleUrls: ['./animated-check.component.scss'],
  imports: [],
})
export class AnimatedCheckComponent {
  @Input() color: string = '';
}
